import { useEffect, useState } from "react";
import Fetch from "../helpers/fetch";
import { apiUrl } from "../../config";

const POLL_INTERVAL = 4000;

/** What the screen can show. Not the provider's vocabulary — see toOrderStatus. */
export const ORDER_STATUS = {
  pending: "pending",
  paid: "paid",
  failed: "failed",
};

/**
 * The provider reports several states (CREATED, PROCESSING, …); only COMPLETED
 * and CANCELED are terminal, so everything else counts as "still waiting".
 */
function toOrderStatus(status) {
  if (status === "COMPLETED") return ORDER_STATUS.paid;
  if (status === "CANCELED") return ORDER_STATUS.failed;
  return ORDER_STATUS.pending;
}

/**
 * Polls /api/intensive/order-status for the user's latest order until it
 * settles, then stops. Does nothing without an email.
 */
export default function useOrderStatus(email, initialStatus) {
  const [status, setStatus] = useState(initialStatus || ORDER_STATUS.pending);

  useEffect(() => {
    if (!email) return;

    let cancelled = false;
    let timer;

    async function poll() {
      try {
        const res = await Fetch.get(
          apiUrl(
            `/api/intensive/order-status?email=${encodeURIComponent(email)}`,
          ),
        );
        if (res.ok) {
          const data = await res.json();
          const next = toOrderStatus(data?.status);
          if (cancelled) return;
          setStatus(next);
          if (next !== ORDER_STATUS.pending) return;
        }
      } catch {
        // network hiccup — retry on the next tick
      }
      if (!cancelled) timer = setTimeout(poll, POLL_INTERVAL);
    }

    poll();
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [email]);

  return status;
}
